import { getDefaultExportFromCjs } from "./_commonjsHelpers.js";
import { __require as requireSrc } from "../node_modules/.pnpm/postcss-discard-duplicates@7.0.2_postcss@8.5.8/node_modules/postcss-discard-duplicates/src/index.js";
var srcExports = requireSrc();
const discardDuplicates = /* @__PURE__ */ getDefaultExportFromCjs(srcExports);
export {
  discardDuplicates as default
};
//# sourceMappingURL=index.js.map
